import React, { Component } from "react";
import CompetitionsCards from "../components/CompetitionsCards";
import '../assets/styles/infi.scss';
import One from '../assets/images/competitions/infi/Mr and Ms Elan.jpg';
import Two from '../assets/images/competitions/infi/Best pick up line.jpg';
import Three from '../assets/images/competitions/infi/Chess.jpg';
import Four from '../assets/images/competitions/infi/Valorant.jpg';
import Five from '../assets/images/competitions/infi/meme.png';
import Six from '../assets/images/competitions/infi/Quiz.png';
import {Image, Modal} from "semantic-ui-react";
import CompetitionDetails from "../components/CompetitionDetails";
import {withUserContext} from "../components/ModalContext";

class Infi extends Component {
  constructor() {
    super();

    this.state = {
      show:false,
      setShow:(val)=>{
        this.setState({show:val})
      },
      modalContent:'',
      setContent:(data)=>{
        this.setState({modalContent:data})
      },
    }

    this.events = [
      {
        name: "Mr And Miss Elan 2021",
        details:
          "Do you think you have the charm, confidence and talent to stand triumphant with all the attention ? Elan & nvision gives you a platform to make your way to name and fame.",
        photo: One,
        btnVisibilty:[true,true],
        submit:'https://forms.gle/eXjUme26erCmTM1f9',
        modal:{
          name:'Mr And Miss Elan 2021',
          data:[
            {
              name:'Rules and Regulations',
              type:'list',
              content:[
                  'This event is exclusively for IITH students\n' ,
                  'Round 1 :  \n' ,
                  'The selected entries from Round 1 will be notified via email and will be promoted to Round 2.   \n' ,
                  'Round 2 : 1) Interview round with our esteemed Judge. \n' ,
                  '\t       2)  A 30 sec video showcasing your talent and creativity. \n' ,
                  'In Round 2, the interview part and video part will have 70 and 30 percent weight respectively.\n' ,
                  'The decision of the judges and the organizers is final and abiding.\n' ,
                  'The winners will be announced on our instagram competitions page - @elan_nvision.competitions. \n',
              ]
            },
            {
              name:'Timeline',
              type:'list',
              content:[

                  'Submission deadline for Round 1 : 6th March 11:59 pm\n' ,
                  'Video submission deadline for Round 2 : 10th March 11:59 pm\n' ,
                  'Interview for Round 2 : 11th March\n' ,
                  'Announcement of winners : 12th March\n' ,
                  'The timings for the interview round will be informed personally to the selected participants via email.\n'
              ]
            },
            {
              name:'Judgement Criteria',
              type:'list',
              content:[
                'Talent\n' ,
                'Creativity\n' ,
                'Personality\n' ,
                'Confidence\n'
              ]
            },
            {
              name:'Prizes',
              type:'text',
              content: 'Exciting vouchers and goodies'

            },
          ]
        }
      },
      {
        name: "BEST PICKUP LINE",
        details:
          "Is the description even needed? Come on…\n" +
            "Just bring out the cheesiness and flirtiness within you!\n",
        photo: Two,
        btnVisibilty:[true,true],
        submit:'https://forms.gle/ybcqd6UucNvNgviU7',
        modal:{
          name:'BEST PICKUP LINE',
          data:[
            {
              name:'Rules and Regulations',
              type:'list',
              content:[
                'Plagiarism is strictly prohibited\n' ,
                'Only 1 entry is allowed per participant\n',
                  'Maximum 3 entries are allowed per participant.',
                'The top 5 submissions will be shared on our instagram competitions page - @elan_nvision.competitions.\n',
                'The top 3 submissions will receive prizes. \n' ,
                'The decision of the judges and the organizers is final and abiding.\n'
              ]
            },
            {
              name:'Timeline ',
              type:'list',
              content:[

                'Submission deadline : 8th March, 11:59pm\n',
                'Announcement of winners : 11th March\n'
              ]
            },
            {
              name:'Prizes',
              type:'text',
              content:'Exciting vouchers and goodies'
            },
          ]
        }
      },
      {
        name: "CHESS",
        details:
          "It is a war over the board. \n" +
            "Elan & nvision invites you to join this war of brains, focus and skills.\n",
        photo: Three,
        btnVisibilty:[true,true],
        submit:'https://forms.gle/Y2V8ZbMsfX64Jfgg8',
        submitAlt:'REGISTER',
        modal:{
          name:'Chess',
          data:[
            {
              name:'Format ',
              type:'list',
              content:[
                'Platform : Lichess\n' ,
                'Tournament duration : 90 min\n' ,
                'Time Control : 2-3 min\n' ,
                'Participants will not be divided into pools. One single tournament will be conducted. \n' ,
                'No berserk is allowed\n' ,
                'Tournament will not be rated.\n'
              ]
            },
            {
              name:'Rules and regulations',
              type:'list',
              content:[
                'Any player using unfair means will be disqualified.\n' ,
                'Players will need to join a discord server for further updates. \n' ,
                'Players need to play on the same lichess account that they have registered. Otherwise, they will not be eligible for prizes. \n' ,
                'Sandbagging will not be tolerated.\n' ,
                'In case of any discrepancy, decisions taken by the organizers will be final and abiding. \n' ,
                'The winners will be given a shout out on our instagram competitions page - @elan_nvision.competitions. \n',
              ]
            },
            {
              name:'Timeline ',
              type:'list',
              content:[

                  'Registration deadline : 6th March\n' ,
                  'Date and time :  6:00pm to 8:00pm on  13th March\n' ,
                  'Rest of the timings will be shared on discord.\n',
              ]
            },
            {
              name:'Prizes',
              type:'text',
              content:'Prize pool of INR 2500 '
            },
          ]
        }
      },
      {
        name: "Valorant",
        details:
          "Love the satisfying feeling of that one tap or the knife.We bring to you an open Valorant tournament conducted in association with fanclash where you can pull out the Aim god in you.",
        photo: Four,
        btnVisibilty:[true,true],
        submit:'https://fanclashapp.page.link/ELAN2021',
        submitAlt:'REGISTER',
        modal:{
          name:'Valorant',
          data:[
            {
              name:'Rules',
              type:'list',
              content:[
                'You have to participate in squads of 5.\n' ,
                'Registration will be done on the fanclash app using the code:\n',
                'Link: https://fanclashapp.page.link/ELAN2021 \n',
                  'Use the Registration Code "IITH21"',
                'All the match/ game rules will be mentioned in the fanclash app.\n',
                ' Registrations will not be accepted after the end date.\n',
              ]
            },
            {
              name:'Timeline',
              type:'list',
              content:[
                'Registration-25th Feb -  5th March\n',
                'Matches start from- 8th March\n',
              ]
            },
            {
              name:'Prizes',
              type:'list',
              content:[
                'Prize pool of Rs 10,000;\n',
                'Winner gets Rs 6000 and Runners up gets Rs 4000\n'
              ]
            },
          ]
        }
      },
      {
        name: "Meme Making",
        details:
          "The age of meme’s has arrived and meme making has become an art form.The meme making competition of Elan & Nvision is here to bring out the comic in you and release the beast.",
        photo: Five,
        btnVisibilty:[true,true],
        submit:'https://forms.gle/NRCd5zf6pFmcWggXA',
        modal:{
          name:'Meme Making',
          data:[
            {
              name:'Rules and Regulations',
              type:'list',
              content:[
                'You can send a maximum of 1 entry via the google form.\n' ,
                'The topic is CHILDHOOD.\n' ,
                'The meme should strictly adhere to the topic mentioned.\n' ,
                'The best 5 among the sent in responses will be considered and posted on our instagram page.\n' ,
                'The respective participants that are able to bring the maximum number of likes for their post will be considered the winner.\n'
              ]
            },
            {
              name:'Timeline ',
              type:'list',
              content:[
                'Taking entries from 1st March -8th March\n' ,
                'Shortlisting and voting for the memes starting from 10th -13th March\n',
              ]
            },
            {
              name:'Prizes',
              type:'text',
              content:'Gift vouchers and goodies'
            },
          ]
        }
      },
      {
        name: "Quiz Hub",
        details:
          "This is a group quiz competition where the questions are fun and the answers even funnier. This is not for those faint hearted ones as the answers are sure to question your existence.",
        photo: Six,
        btnVisibilty:[true,true],
        submit:'https://forms.gle/7LWXCbUZkFJ39Nky6',
        submitAlt:'REGISTER',
        modal:{
          name:'Quiz Hub',
          data:[
            {
              name:'Rules and Regulations',
              type:'list',
              content:[
                'You have to participate in teams of four.\n' ,
                'The top 4 teams will be considered for the second round ,the ranking’s will be decided\n' +
                'based on the number of questions answered correctly and how fast you answered based\n' +
                'on your time of submission.\n' ,
                'The quizzes will be sent to your mail at sharp 5pm on March 7th\n' ,
                'The second round will have many variations from buzzer beaters, round the table, and\n' +
                'randomised while using various platforms like discord etc.\n' ,
                'The points of the teams will be mentioned aοer each round and the positions of the\n' +
                'respective teams.\n' ,
                'Answering when it’s not your turn will not be allowed.\n' ,
                'Each question has a time limit to be answered.\n' ,
                'Googling for the answer is not accepted.\n' ,
                'The quiz will be streamed and the participants will have to display their face for some of\n' +
                'the questions',
              ]
            },
            {
              name:'Timeline ',
              type:'list',
              content:[
                'Registrations : 6th March\n' ,
                'Date of quiz: 10th March'
              ]
            },
            {
              name:'Prizes',
              type:'text',
              content:' Gift vouchers and goodies\n'
            },
          ]
        }
      },
    ];
  }

  render() {
    return (<>
      <div className={"infi"}>
        <h1>Infi Events</h1>
        <button className={'schedule-link'} onClick={()=>this.props.setShowSchedule(true)}>Schedule</button>
        <div className={"card-container"}>
            {this.events.map(item=>{
                return <CompetitionsCards setContent={this.state.setContent} setShow={this.state.setShow} {...item} />
            })}
        </div>
      </div>
      <Modal
          size={'big'}
          open={this.state.show}
          onClose={() => this.state.setShow(false)}
          closeIcon={true}
          className={'competitions-modal'}
          style={{zIndex:'99'}}

      >
        <Modal.Header className={'modal-header'}>
        </Modal.Header>
        <Modal.Content className={'modal-content'}>
          <CompetitionDetails {...this.state.modalContent}/>
        </Modal.Content>

      </Modal>
    </>);
  }
}

export default withUserContext(Infi);
